import { Anchor, Group, HoverCard, Stack, Text } from "@mantine/core";
import { useLanguage } from "../../../../../../stores/LanguageStore";

const ArgumentsGoogle = ({ item }) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Stack mt={"xs"} gap={"xs"}>
      <Group>
        <Text mr={"xs"}>{lang.contact_lists.jobs.completed.google_links}</Text>
        {item?.arguments?.googleMapsSearchUrls.length === 1 ? (
          <Anchor
            href={item?.arguments?.googleMapsSearchUrls[0] || ""}
            target="_blank"
            fw={500}
            fz={12}
            truncate="end"
          >
            {item?.arguments?.googleMapsSearchUrls[0] || ""}
          </Anchor>
        ) : (
          <HoverCard>
            <HoverCard.Target>
              <Text fw={500}>
                {item?.arguments?.googleMapsSearchUrls?.length}{" "}
                <span style={{ opacity: 0.5, fontWeight: 400, fontSize: 12 }}>
                  {lang.contact_lists.jobs.completed.hover_to_show}
                </span>
              </Text>
            </HoverCard.Target>

            <HoverCard.Dropdown>
              <Stack maxHeight={150} overflow={"auto"}>
                {item?.arguments?.googleMapsSearchUrls?.map((link) => (
                  <Anchor
                    key={link}
                    href={link || "#"}
                    target="_blank"
                    fontSize={12}
                    truncate="end"
                    flexGrow={1}
                    c="inherit"
                  >
                    {link || ""} <br />
                  </Anchor>
                ))}
              </Stack>
            </HoverCard.Dropdown>
          </HoverCard>
        )}
      </Group>
      <Text>
        {lang.contact_lists.jobs.completed.max_profiles}{" "}
        <b>{item?.arguments?.maxResults}</b>
      </Text>
    </Stack>
  );
};

export default ArgumentsGoogle;
